import { Col } from '@opendoor/atoms/box';

import ExploreHomes from './ExploreHomes';
import Hero from './Hero';
import HomeLoansSavings from './HomeLoansSavings';
import { useListingNavigation } from './useListingNavigation';
import WhySubmitOnline from './WhySubmitOnline';

/**
 * `/make-offer/start` — the top of the Offer Portal funnel, where a buyer's
 * agent enters the property their client wants to offer on.
 */
const OfferPortalLanding = () => {
  const goToListing = useListingNavigation();

  return (
    // Per design: the page sits on the greyish secondary background so the
    // white value-prop icon chips read against it.
    <Col className="w-full gap-16 bg-od-bg-secondary pb-16 lg:gap-[126px]">
      <Hero onSubmit={goToListing} />
      <WhySubmitOnline />
      <HomeLoansSavings />
      <ExploreHomes />
    </Col>
  );
};

export default OfferPortalLanding;
